import type { Channel } from 'stream-chat'

/** Stream send options: do not scrape URLs into OG / link-preview attachments. */
export const IN_TOUCH_CHAT_MESSAGE_SEND_OPTIONS = {
  skip_enrich_url: true,
} as const

export function mergeInTouchChatSendOptions (sendOptions?: Record<string, unknown>): Record<string, unknown> {
  return {
    ...sendOptions,
    ...IN_TOUCH_CHAT_MESSAGE_SEND_OPTIONS,
  }
}

/** Client-side chat policy: no link previews while composing or on the wire. */
export function configureInTouchChatChannel (channel: Channel): void {
  const messageComposer = channel.messageComposer

  if (!messageComposer?.updateConfig) {
    return
  }

  messageComposer.updateConfig({
    linkPreviews: { enabled: false },
  })
  messageComposer.linkPreviewsManager?.clearPreviews()
}
